import { render, staticRenderFns } from "./editReturnfeeSubmit.vue?vue&type=template&id=20b6bd59&scoped=true&"
import script from "./editReturnfeeSubmit.vue?vue&type=script&lang=js&"
export * from "./editReturnfeeSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editReturnfeeSubmit.vue?vue&type=style&index=0&id=20b6bd59&scoped=true&lang=css&"
import style1 from "./editReturnfeeSubmit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6bd59",
  null
  
)

export default component.exports